
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-holographic-rc';

      const presets = [
        { name: 'Eraser', css: null, rgb: [0, 0, 0] },
        { name: 'Black', css: '#000', rgb: [0, 0, 0] },
        { name: 'Red', css: '#ff4444', rgb: [1, 0.25, 0.25] },
        { name: 'Orange', css: '#ff8833', rgb: [1, 0.5, 0.2] },
        { name: 'Yellow', css: '#dddd33', rgb: [0.75, 0.75, 0.2] },
        { name: 'Green', css: '#44dd55', rgb: [0.25, 0.8, 0.35] },
        { name: 'Cyan', css: '#44dddd', rgb: [0.25, 0.75, 0.75] },
        { name: 'Blue', css: '#4466ff', rgb: [0.3, 0.4, 1] },
        { name: 'Purple', css: '#aa44ff', rgb: [0.65, 0.3, 1] },
        { name: 'White', css: '#ffffff', rgb: [0.8, 0.8, 0.8] },
      ];

      const toHex = (rgb) =>
        '#' +
        rgb
          .map((c) =>
            Math.round(Math.pow(Math.max(0, Math.min(1, c)), 1 / 2.2) * 255)
              .toString(16)
              .padStart(2, '0'),
          )
          .join('');
      const fromHex = (h) => [h.slice(1, 3), h.slice(3, 5), h.slice(5, 7)].map((s) => (parseInt(s, 16) / 255) ** 2.2);

      const pen = { color: [0.8, 0.8, 0.8], opacity: 1, albedo: 0, size: 16, eraser: false };
      let selectedShape = null;
      let panelOpen = false;

      const $ = (id) => document.getElementById(id);
      const hrc = $('hrc');
      const panelEl = $('panel');
      const panelTitle = $('panel-title');
      const swatchesEl = $('swatches');
      const customColor = $('custom-color');
      const colorBtn = $('color-btn');
      const sOpacity = $('p-opacity'),
        vOpacity = $('v-opacity');
      const sAlbedo = $('p-albedo'),
        vAlbedo = $('v-albedo');
      const sSize = $('p-size'),
        vSize = $('v-size');
      const sizeRow = $('size-row');
      const exposureSlider = $('exposure-slider'),
        exposureValue = $('exposure-value');
      const probeSlider = $('probe-slider'),
        probeValue = $('probe-value');
      const sceneSelect = $('scene-select');

      // ── Panel toggle ──
      function togglePanel(force) {
        panelOpen = force !== undefined ? force : !panelOpen;
        panelEl.classList.toggle('open', panelOpen);
        colorBtn.classList.toggle('open', panelOpen);
      }
      colorBtn.addEventListener('click', () => togglePanel());

      // ── Info popup ──
      const infoPopup = $('info-popup');
      $('info-btn').addEventListener('click', () => {
        infoPopup.classList.toggle('open');
      });
      document.addEventListener('click', (e) => {
        if (!e.target.closest('#info-popup') && !e.target.closest('#info-btn')) {
          infoPopup.classList.remove('open');
        }
      });

      // ── Fullscreen ──
      $('fs-btn').addEventListener('click', () => {
        if (document.fullscreenElement) document.exitFullscreen();
        else document.documentElement.requestFullscreen();
      });

      // ── Swatches ──
      const swatchEls = [];
      presets.forEach((p, i) => {
        const el = document.createElement('div');
        el.className = 'sw' + (i === 0 ? ' eraser' : '');
        if (p.css) el.style.backgroundColor = p.css;
        el.title = p.name;
        el.addEventListener('click', () => pickPreset(i));
        swatchesEl.insertBefore(el, customColor);
        swatchEls.push(el);
      });

      function pickPreset(idx) {
        pen.eraser = idx === 0;
        if (idx > 0) pen.color = [...presets[idx].rgb];
        if (selectedShape && idx > 0) selectedShape.setAttribute('data-rgb', pen.color.join(','));
        syncPanel();
        syncMouse();
      }

      customColor.addEventListener('input', () => {
        pen.color = fromHex(customColor.value);
        pen.eraser = false;
        if (selectedShape) selectedShape.setAttribute('data-rgb', pen.color.join(','));
        syncPanel();
        syncMouse();
      });

      // ── Panel slider wiring ──
      const f2 = (v) => v.toFixed(2);
      const f3 = (v) => (v < 0.1 ? v.toFixed(3) : v.toFixed(2));

      sOpacity.addEventListener('input', () => {
        const raw = Number(sOpacity.value);
        const opacity = raw * raw * raw;
        vOpacity.textContent = f3(opacity);
        if (selectedShape) selectedShape.setAttribute('data-opacity', String(opacity));
        else { pen.opacity = opacity; syncMouse(); }
      });
      sAlbedo.addEventListener('input', () => {
        const v = Number(sAlbedo.value);
        vAlbedo.textContent = f2(v);
        if (selectedShape) selectedShape.setAttribute('data-albedo', String(v));
        else { pen.albedo = v; syncMouse(); }
      });
      sSize.addEventListener('input', () => {
        pen.size = Number(sSize.value);
        vSize.textContent = String(pen.size);
        hrc.setMouseLightRadius(pen.size / 2);
      });

      function syncPanel() {
        const shape = selectedShape;
        panelTitle.textContent = shape ? 'Shape' : 'Pen';
        sizeRow.style.display = shape ? 'none' : '';

        let color, opacity, albedo;
        if (shape) {
          const rgbAttr = shape.getAttribute('data-rgb');
          color = rgbAttr ? rgbAttr.split(',').map(Number) : [0, 0, 0];
          opacity = Number(shape.getAttribute('data-opacity') ?? 1);
          albedo = Number(shape.getAttribute('data-albedo') ?? 0);
        } else {
          ({ color, opacity, albedo } = pen);
        }

        customColor.value = toHex(color);
        sOpacity.value = Math.cbrt(opacity);
        vOpacity.textContent = f3(opacity);
        sAlbedo.value = albedo;
        vAlbedo.textContent = f2(albedo);
        if (!shape) {
          sSize.value = pen.size;
          vSize.textContent = String(pen.size);
        }

        swatchEls.forEach((el, i) => el.classList.toggle('active', pen.eraser && i === 0));
        colorBtn.style.backgroundColor = pen.eraser ? '' : toHex(shape ? color : pen.color);
      }

      function selectShape(shape) {
        if (selectedShape) selectedShape.style.outline = '';
        selectedShape = shape;
        if (shape) {
          shape.style.outline = '2px solid rgba(100, 180, 255, 0.8)';
          togglePanel(true);
        }
        syncPanel();
      }

      function syncMouse() {
        const [r, g, b] = pen.eraser ? [0, 0, 0] : pen.color;
        hrc.setMouseLightColor(r, g, b);
        hrc.setMouseLightMaterial(pen.eraser ? 0 : pen.opacity, pen.albedo);
      }

      // ── Shape selection ──
      hrc.addEventListener('focusin', (e) => {
        if (e.target.tagName === 'FOLK-SHAPE') selectShape(e.target);
      });
      document.addEventListener('pointerdown', (e) => {
        if (!selectedShape) return;
        if (e.target.closest('#panel') || e.target.closest('#controls')) return;
        if (e.target.tagName === 'FOLK-SHAPE') return;
        selectShape(null);
      });

      // ── Controls ──
      function setExposure(v) {
        v = Math.max(0.1, Math.min(10, v));
        hrc.exposure = v;
        exposureSlider.value = v;
        exposureValue.textContent = v.toFixed(1);
      }
      const normalCounts = [
        ...new Set([32, 64, 128, 256, 512, 1024, 2048, ...Array.from({ length: 20 }, (_, i) => (i + 1) * 100)]),
      ].sort((a, b) => a - b);
      const ppCounts = [16, 32, 64, 128, 256, 512, 1024, 2048];
      let ppMode = false;
      let probeCounts = normalCounts;

      function setProbeSize(size) {
        const idx = probeCounts.indexOf(size);
        const i = idx >= 0 ? idx : probeCounts.findIndex((v) => v >= size) || probeCounts.length - 1;
        const actual = probeCounts[Math.max(0, i)];
        hrc.probeCount = actual;
        probeSlider.max = probeCounts.length - 1;
        probeSlider.value = Math.max(0, i);
        probeValue.textContent = actual;
        if (ppMode) hrc.pixelPerfect = actual;
      }

      function setPPMode(on) {
        ppMode = on;
        probeCounts = on ? ppCounts : normalCounts;
        if (on) {
          const nearest = ppCounts.reduce((best, v) =>
            Math.abs(v - hrc.probeCount) < Math.abs(best - hrc.probeCount) ? v : best,
          );
          hrc.pixelPerfect = nearest;
          setProbeSize(nearest);
        } else {
          hrc.pixelPerfect = 0;
          setProbeSize(hrc.probeCount);
        }
      }

      // ── URL state ──
      const urlDefaults = { scene: 0, sky: 'none', probes: 1024, exposure: 2, bounces: true, debug: 0, fc: false, '1px': false, perf: false };

      function loadURL() {
        const p = new URLSearchParams(location.search);
        return {
          scene: Number(p.get('scene') ?? urlDefaults.scene),
          sky: p.get('sky') ?? urlDefaults.sky,
          probes: Number(p.get('probes') ?? urlDefaults.probes),
          exposure: Number(p.get('exposure') ?? urlDefaults.exposure),
          bounces: p.get('bounces') !== '0',
          debug: Number(p.get('debug') ?? urlDefaults.debug),
          fc: p.get('fc') === '1',
          '1px': p.get('1px') === '1',
          perf: p.get('perf') === '1',
        };
      }

      function syncURL() {
        const p = new URLSearchParams();
        if (currentScene !== 0) p.set('scene', currentScene);
        if (skySelect.value !== 'none') p.set('sky', skySelect.value);
        if (hrc.probeCount !== 1024) p.set('probes', hrc.probeCount);
        if (hrc.exposure !== 2) p.set('exposure', hrc.exposure.toFixed(1));
        if (!hrc.bounces) p.set('bounces', '0');
        if (hrc.debugMode > 0) p.set('debug', hrc.debugMode);
        if (hrc.falseColor) p.set('fc', '1');
        if (ppMode) p.set('1px', '1');
        if (perfOpen) p.set('perf', '1');
        const qs = p.toString();
        history.replaceState(null, '', qs ? '?' + qs : location.pathname);
      }

      const initState = loadURL();
      let perfOpen = initState.perf;

      exposureSlider.addEventListener('input', () => { setExposure(Number(exposureSlider.value)); syncURL(); });
      probeSlider.addEventListener('input', () => { setProbeSize(probeCounts[Number(probeSlider.value)]); syncURL(); });
      setProbeSize(initState.probes);
      $('bounces-toggle').addEventListener('change', (e) => { hrc.bounces = e.target.checked; syncURL(); });
      const ppToggle = $('pp-toggle');
      ppToggle.addEventListener('change', (e) => { setPPMode(e.target.checked); syncURL(); });
      const debugSelect = $('debug-select');
      debugSelect.addEventListener('change', () => { hrc.debugMode = Number(debugSelect.value); syncURL(); });
      const fcToggle = $('fc-toggle');
      fcToggle.addEventListener('change', (e) => { hrc.falseColor = e.target.checked; syncURL(); });

      $('load-btn').addEventListener('click', () => $('scene-file').click());
      $('save-btn').addEventListener('click', () => hrc.saveScenePNG(`scene-${Date.now()}.png`));
      $('scene-file').addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const img = new Image();
        img.onload = () => {
          hrc.loadSceneImage(img);
          ppToggle.checked = true;
          ppMode = true;
          probeCounts = ppCounts;
          setProbeSize(img.width);
          syncURL();
        };
        img.src = URL.createObjectURL(file);
        e.target.value = '';
      });

      hrc.setMouseLightRadius(pen.size / 2);
      syncMouse();
      syncPanel();

      // ── Sky controls ──
      const skySelect = $('sky-select');
      function buildSky(fn) {
        const PI = Math.PI,
          N = 256,
          data = new Float32Array(N * 4);
        function wrap(d) {
          return d > PI ? d - PI * 2 : d < -PI ? d + PI * 2 : d;
        }
        function spot(angle, sigma, color) {
          const inv = 1 / (2 * sigma * sigma);
          for (let i = 0; i < N; i++) {
            const a = (i / N) * PI * 2 - PI;
            const w = wrap(a - angle);
            const g = Math.exp(-(w * w) * inv);
            data[i * 4] += color[0] * g;
            data[i * 4 + 1] += color[1] * g;
            data[i * 4 + 2] += color[2] * g;
          }
        }
        function fill(color) {
          for (let i = 0; i < N; i++) {
            data[i * 4] += color[0];
            data[i * 4 + 1] += color[1];
            data[i * 4 + 2] += color[2];
          }
        }
        function arc(center, halfWidth, color) {
          for (let i = 0; i < N; i++) {
            const a = (i / N) * PI * 2 - PI;
            const d = Math.abs(wrap(a - center));
            const t = Math.max(0, 1 - d / halfWidth);
            data[i * 4] += color[0] * t;
            data[i * 4 + 1] += color[1] * t;
            data[i * 4 + 2] += color[2] * t;
          }
        }
        function hueRing(intensity, saturation, offset) {
          for (let i = 0; i < N; i++) {
            const h = (i / N + (offset || 0)) % 1;
            const s = saturation ?? 1;
            const k = (n) => (n + h * 6) % 6;
            const f = (n) => intensity * (1 - s * Math.max(0, Math.min(k(n), 4 - k(n), 1)));
            data[i * 4] += f(0);
            data[i * 4 + 1] += f(4);
            data[i * 4 + 2] += f(2);
          }
        }
        fn({ spot, fill, arc, hueRing, PI, N, data, wrap });
        for (let i = 0; i < N; i++) data[i * 4 + 3] = 1;
        hrc.setSkyCircle(data);
      }

      function applySky(name) {
        const PI = Math.PI;
        switch (name) {
          case 'none':
            hrc.clearSky();
            break;
          case 'overcast':
            hrc.setSkyColor(0.04, 0.045, 0.05);
            break;
          case 'spectrum':
            buildSky(({ hueRing }) => {
              hueRing(1.5, 1, 0);
            });
            break;
          case 'iridescent':
            buildSky(({ PI, N, data }) => {
              for (let i = 0; i < N; i++) {
                const t = i / N;
                const phase = t * PI * 3;
                const r = 0.5 + 0.5 * Math.cos(phase);
                const g = 0.5 + 0.5 * Math.cos(phase + PI * 0.7);
                const b = 0.5 + 0.5 * Math.cos(phase + PI * 1.4);
                const brightness = 0.6 + 0.4 * Math.cos(t * PI * 2);
                data[i * 4] = r * brightness;
                data[i * 4 + 1] = g * brightness;
                data[i * 4 + 2] = b * brightness;
              }
            });
            break;
          case 'studio':
            buildSky(({ spot, PI }) => {
              spot(-PI * 0.65, 0.08, [2.2, 2.4, 2.8]);
              spot(-PI * 0.35, 0.1, [2.5, 2.2, 1.8]);
              spot(PI * 0.8, 0.12, [2.0, 2.0, 2.3]);
            });
            break;
          case 'rgb':
            buildSky(({ spot, PI }) => {
              const s = (PI * 2) / 3;
              spot(-PI / 2, 0.04, [4, 0.05, 0.05]);
              spot(-PI / 2 + s, 0.04, [0.05, 4, 0.05]);
              spot(-PI / 2 + s * 2, 0.04, [0.05, 0.05, 4]);
            });
            break;
          case 'sunset':
            buildSky(({ spot, PI, N, data }) => {
              spot(-PI / 8, 0.09, [1.8, 0.5, 0.15]);
              for (let i = 0; i < N; i++) {
                const a = (i / N) * PI * 2 - PI;
                const vert = Math.sin(a) * 0.5 + 0.5;
                data[i * 4] += 0.08 * (1 - vert);
                data[i * 4 + 1] += 0.03 * (1 - vert);
                data[i * 4 + 2] += 0.06 * vert;
              }
            });
            break;
          case 'moonlight':
            buildSky(({ spot, fill, PI }) => {
              spot(-PI / 3, 0.04, [0.4, 0.5, 0.7]);
              fill([0.002, 0.003, 0.006]);
            });
            break;
        }
      }
      skySelect.addEventListener('change', () => {
        applySky(skySelect.value);
        syncURL();
      });

      // ── Scene infrastructure ──
      let animationId = null;

      function clearScene() {
        if (animationId) {
          cancelAnimationFrame(animationId);
          animationId = null;
        }
        hrc.clearLines();
        hrc.querySelectorAll('folk-shape').forEach((s) => s.remove());
      }

      function addShape(x, y, w, h, colorIdx, opts) {
        const el = document.createElement('folk-shape');
        el.setAttribute('x', x);
        el.setAttribute('y', y);
        el.setAttribute('width', w);
        el.setAttribute('height', h);
        if (colorIdx !== undefined) el.setAttribute('data-rgb', (presets[colorIdx]?.rgb ?? [0, 0, 0]).join(','));
        if (opts && typeof opts === 'object') {
          if (opts.opacity !== undefined) el.setAttribute('data-opacity', String(opts.opacity));
          if (opts.albedo !== undefined) el.setAttribute('data-albedo', String(opts.albedo));
          if (opts.color) el.setAttribute('data-rgb', opts.color.join(','));
        }
        hrc.appendChild(el);
        return el;
      }

      let currentScene = 0;
      function switchScene(index) {
        currentScene = index;
        document.activeElement?.blur();
        selectShape(null);
        clearScene();
        scenes[index].fn();
        sceneSelect.value = currentScene;
        syncURL();
      }

      // ── Scene definitions ──
      // Static scenes: shapes are [dx, dy, w, h, colorIdx, opts?] relative to center.
      // 'H' in dy means relative to full height (for pinhole walls).
      function loadStatic(shapes) {
        const cx = window.innerWidth / 2, cy = hrc.clientHeight / 2;
        for (const s of shapes) {
          const [dx, dy, w, h, c, opts] = s;
          addShape(cx + dx, cy + dy, w, h, c, opts);
        }
      }

      // Furnace test needs a procedural loop
      function loadFurnaceTest() {
        const cx = window.innerWidth / 2, cy = hrc.clientHeight / 2, r = 120, t = 20;
        for (let i = 0; i < 32; i++) {
          const a0 = (i / 32) * Math.PI * 2, a1 = ((i + 1) / 32) * Math.PI * 2;
          const x0 = cx + Math.cos(a0) * r, y0 = cy + Math.sin(a0) * r;
          const x1 = cx + Math.cos(a1) * r, y1 = cy + Math.sin(a1) * r;
          addShape(Math.min(x0, x1) - t / 2, Math.min(y0, y1) - t / 2, Math.max(Math.abs(x1 - x0) + t, t), Math.max(Math.abs(y1 - y0) + t, t), 3);
        }
      }

      // Animated scenes keep their functions
      function loadAnimated(staticShapes, setupAndAnimate) {
        const cx = window.innerWidth / 2, cy = hrc.clientHeight / 2;
        for (const s of staticShapes) addShape(cx + s[0], cy + s[1], s[2], s[3], s[4], s[5]);
        setupAndAnimate(cx, cy);
      }

      const S = {
        pinhole: [
          [-200, -84, 16, 24, 2], [-200, -60, 16, 24, 3], [-200, -36, 16, 24, 4],
          [-200, -12, 16, 24, 5], [-200, 12, 16, 24, 6], [-200, 36, 16, 24, 7], [-200, 60, 16, 24, 8],
          [-5, -500, 8, 488, 1], [-5, 12, 8, 500, 1],
        ],
        centerBlock: [[-60, -60, 120, 120, 1]],
        thinWalls: [[-200, -80, 400, 1, 1], [-200, -20, 400, 2, 1], [-200, 40, 400, 4, 1], [-200, 110, 400, 8, 1]],
        colorShadows: [[-200, -100, 40, 40, 2], [-200, 60, 40, 40, 7], [-40, -80, 20, 160, 1], [100, -120, 10, 240, 9]],
        stainedGlass: [
          [-10, -120, 20, 30, 1], [-10, -90, 20, 40, 2, {opacity: 0.6}], [-10, -50, 20, 40, 5, {opacity: 0.6}],
          [-10, -10, 20, 40, 7, {opacity: 0.6}], [-10, 30, 20, 40, 4, {opacity: 0.6}], [-10, 70, 20, 30, 1],
        ],
        glowingFog: [
          [-200, -40, 60, 60, 9], [-80, -100, 60, 200, 2, {opacity: 0.015, albedo: 0.5}],
          [-10, -100, 60, 200, 5, {opacity: 0.015, albedo: 0.5}], [60, -100, 60, 200, 7, {opacity: 0.015, albedo: 0.5}],
          [180, -40, 40, 80, 1],
        ],
        fogRoom: [
          [-250, -200, 500, 15, 1], [-250, 185, 500, 15, 1], [-250, -200, 15, 400, 1], [235, -200, 15, 400, 1],
          [-200, -185, 30, 30, 3], [170, 155, 30, 30, 6], [-100, -50, 200, 100, 0, {opacity: 0.01, albedo: 0.99}],
        ],
        smoke: [[-30, 80, 60, 30, 3], [-80, -100, 160, 160, 0, {opacity: 0.05, albedo: 0.9}], [-200, -60, 30, 30, 1], [170, -60, 30, 30, 1]],
        bounceRoom: [
          [-250, -200, 500, 15, 0, {albedo: 0.7}], [-250, 185, 500, 15, 0, {albedo: 0.7}],
          [-250, -200, 15, 400, 0, {albedo: 0.7}], [235, -200, 15, 400, 0, {albedo: 0.7}],
          [-40, -190, 80, 10, 9], [-30, -30, 60, 60, 1], [-248, 50, 10, 20, 2],
        ],
        bounceMaze: [
          [-310, -200, 300, 20, 0, {albedo: 0.9}], [-310, 180, 300, 20, 0, {albedo: 0.9}],
          [-310, -200, 20, 400, 0, {albedo: 0.9}], [-20, -200, 20, 400, 0, {albedo: 0.9}],
          [-200, -70, 20, 270, 0, {albedo: 0.9}], [-110, -180, 20, 200, 0, {albedo: 0.9}], [-300, -190, 20, 20, 9],
          [10, -200, 300, 20, 0, {albedo: 0.3}], [10, 180, 300, 20, 0, {albedo: 0.3}],
          [10, -200, 20, 400, 0, {albedo: 0.3}], [290, -200, 20, 400, 0, {albedo: 0.3}],
          [120, -70, 20, 270, 0, {albedo: 0.3}], [210, -180, 20, 200, 0, {albedo: 0.3}], [20, -190, 20, 20, 9],
        ],
        scattering: [
          [-250, -20, 30, 40, 9], [-150, -150, 250, 300, 0, {opacity: 0.03, albedo: 1}],
          [-10, -60, 20, 120, 1], [150, -100, 150, 200, 0, {opacity: 0.03}], [350, -20, 30, 40, 9],
        ],
        materials: [
          [-245, -20, 50, 50, 3], [-175, -20, 50, 50, 1], [-105, -20, 50, 50, 2, {opacity: 0.6}],
          [-35, -20, 50, 50, 0, {opacity: 0.05, albedo: 0.8}], [35, -20, 50, 50, 0, {albedo: 0.8}],
          [105, -20, 50, 50, 0, {opacity: 0.3}], [175, -20, 50, 50, 5, {opacity: 0.03, albedo: 0.5}],
          [245, -20, 50, 50, 5, {opacity: 0.6}], [-30, -150, 60, 15, 9],
        ],
      };

      const scenes = [
        { name: 'Pinhole', fn: () => loadStatic(S.pinhole) },
        { name: 'Center block', fn: () => loadStatic(S.centerBlock) },
        { name: 'Thin walls', fn: () => loadStatic(S.thinWalls) },
        { name: 'Color shadows', fn: () => loadStatic(S.colorShadows) },
        { name: 'Stained glass', fn: () => loadStatic(S.stainedGlass) },
        { name: 'Glowing fog', fn: () => loadStatic(S.glowingFog) },
        { name: 'Fog room', fn: () => loadStatic(S.fogRoom) },
        { name: 'Smoke', fn: () => loadStatic(S.smoke) },
        { name: 'Bounce room', fn: () => loadStatic(S.bounceRoom) },
        { name: 'Bounce maze', fn: () => loadStatic(S.bounceMaze) },
        { name: 'Scattering', fn: () => loadStatic(S.scattering) },
        { name: 'Materials', fn: () => loadStatic(S.materials) },
        { name: 'Furnace test', fn: loadFurnaceTest },
        { name: 'Color mix', fn() {
          const cx = window.innerWidth / 2, cy = hrc.clientHeight / 2;
          addShape(cx - 40, cy - 40, 80, 80, 1);
          const shapes = [addShape(cx - 150, cy - 120, 50, 50, 2), addShape(cx + 100, cy - 120, 50, 50, 5), addShape(cx - 25, cy + 100, 50, 50, 7)];
          const angles = [-Math.PI * 0.75, -Math.PI * 0.25, Math.PI * 0.5];
          (function animate() { const t = performance.now() / 2500; shapes.forEach((s, i) => { const r = 140 * (0.5 + 0.5 * Math.sin(t + i * Math.PI * 2 / 3)); s.setAttribute('x', cx + Math.cos(angles[i]) * r - 25); s.setAttribute('y', cy + Math.sin(angles[i]) * r - 25); }); animationId = requestAnimationFrame(animate); })();
        }},
        { name: 'Orbit', fn() {
          const cx = window.innerWidth / 2, cy = hrc.clientHeight / 2;
          addShape(cx - 20, cy - 180, 40, 40, 2); addShape(cx + 140, cy - 20, 40, 40, 5); addShape(cx - 20, cy + 140, 40, 40, 7); addShape(cx - 180, cy - 20, 40, 40, 4);
          const block = addShape(cx - 30, cy - 30, 60, 60, 1);
          (function animate() { const t = performance.now() / 2000; block.setAttribute('x', cx + Math.cos(t) * 100 - 30); block.setAttribute('y', cy + Math.sin(t) * 100 - 30); animationId = requestAnimationFrame(animate); })();
        }},
        { name: 'Gate', fn() {
          const cx = window.innerWidth / 2, cy = hrc.clientHeight / 2;
          const orange = addShape(cx - 250, cy - 25, 50, 50, 3), left = addShape(cx - 160, cy - 10, 140, 20, 1), right = addShape(cx + 20, cy - 10, 140, 20, 1), cyan = addShape(cx + 200, cy - 25, 50, 50, 6);
          (function animate() { const t = performance.now() / 3000; const gap = 20 + Math.abs(Math.sin(t)) * 120; left.setAttribute('x', cx - gap / 2 - 140); right.setAttribute('x', cx + gap / 2); orange.setAttribute('y', cy - 25 + Math.sin(t * 1.3) * 80); cyan.setAttribute('y', cy - 25 - Math.sin(t * 1.3) * 80); animationId = requestAnimationFrame(animate); })();
        }},
        { name: 'Breathing', fn() {
          const cx = window.innerWidth / 2, cy = hrc.clientHeight / 2;
          const emL = addShape(cx - 220, cy - 20, 40, 40, 3), emR = addShape(cx + 180, cy - 20, 40, 40, 6);
          const fog = addShape(cx - 100, cy - 100, 200, 200, 0, {opacity: 0.02, albedo: 0.8}), wall = addShape(cx - 10, cy - 80, 20, 160, 0, {albedo: 0.5});
          (function animate() { const t = performance.now() / 2000; fog.setAttribute('data-opacity', (0.01 + 0.025 * (0.5 + 0.5 * Math.sin(t))).toFixed(4)); fog.setAttribute('data-albedo', (0.4 + 0.5 * (0.5 + 0.5 * Math.sin(t * 1.3))).toFixed(3)); const li = 0.3 + 0.7 * (0.5 + 0.5 * Math.sin(t * 0.7)); emL.setAttribute('data-rgb', [li, li * 0.5, li * 0.2].map(v => v.toFixed(3)).join(',')); const ri = 0.3 + 0.7 * (0.5 + 0.5 * Math.cos(t * 0.7)); emR.setAttribute('data-rgb', [ri * 0.2, ri * 0.7, ri].map(v => v.toFixed(3)).join(',')); wall.setAttribute('data-albedo', (0.3 + 0.5 * (0.5 + 0.5 * Math.sin(t * 0.5))).toFixed(3)); animationId = requestAnimationFrame(animate); })();
        }},
        { name: 'Spectrum', fn() {
          const cx = window.innerWidth / 2, cy = hrc.clientHeight / 2, t = 15;
          [[cx - 200, cy - 150, 400, t], [cx - 200, cy + 150 - t, 400, t], [cx - 200, cy - 150, t, 300], [cx + 200 - t, cy - 150, t, 300]].forEach(([x, y, w, h]) => addShape(x, y, w, h, 0, {albedo: 0.85}));
          const emitter = addShape(cx - 15, cy - 145, 30, 10, 9); addShape(cx - 30, cy - 30, 60, 60, 1);
          (function animate() { const time = performance.now() / 3000; emitter.setAttribute('data-rgb', [0.5 + 0.5 * Math.sin(time), 0.5 + 0.5 * Math.sin(time + 2.094), 0.5 + 0.5 * Math.sin(time + 4.189)].map(v => v.toFixed(3)).join(',')); animationId = requestAnimationFrame(animate); })();
        }},
        { name: 'Material cycle', fn() {
          const cx = window.innerWidth / 2, cy = hrc.clientHeight / 2;
          addShape(cx - 180, cy - 20, 30, 40, 9); addShape(cx + 150, cy - 20, 30, 40, 6);
          const obj = addShape(cx - 40, cy - 40, 80, 80, 0, {opacity: 1, albedo: 0});
          const fog1 = addShape(cx - 120, cy - 80, 80, 160, 0, {opacity: 0.02, albedo: 0.6}), fog2 = addShape(cx + 40, cy - 80, 80, 160, 0, {opacity: 0.02, albedo: 0.6});
          (function animate() { const t = performance.now() / 4000; const phase = t % 3; let opacity, albedo, r, g, b; if (phase < 1) { opacity = 1; albedo = 0; const c = 0.5 + 0.5 * Math.sin(t * 3); r = c; g = c * 0.4; b = c * 0.2; } else if (phase < 2) { opacity = 1; albedo = 0.3 + 0.6 * (phase - 1); r = 0.05; g = 0.05; b = 0.05; } else { opacity = 1 - 0.97 * (phase - 2); albedo = phase - 2; r = 0; g = 0; b = 0; } obj.setAttribute('data-rgb', [r, g, b].map(v => v.toFixed(3)).join(',')); obj.setAttribute('data-opacity', opacity.toFixed(3)); obj.setAttribute('data-albedo', albedo.toFixed(3)); const fogOp = 0.01 + 0.015 * (0.5 + 0.5 * Math.sin(t * 1.5)); fog1.setAttribute('data-opacity', fogOp.toFixed(4)); fog2.setAttribute('data-opacity', fogOp.toFixed(4)); animationId = requestAnimationFrame(animate); })();
        }},
      ];

      scenes.forEach((s, i) => {
        const o = document.createElement('option');
        o.value = i;
        o.textContent = `${i}: ${s.name}`;
        sceneSelect.appendChild(o);
      });
      sceneSelect.addEventListener('change', () => switchScene(Number(sceneSelect.value)));

      ppToggle.checked = initState['1px'];
      if (initState['1px']) setPPMode(true);
      skySelect.value = initState.sky;
      applySky(initState.sky);
      setExposure(initState.exposure);
      hrc.bounces = initState.bounces;
      $('bounces-toggle').checked = initState.bounces;
      hrc.debugMode = initState.debug;
      debugSelect.value = initState.debug;
      hrc.falseColor = initState.fc;
      fcToggle.checked = initState.fc;
      switchScene(initState.scene);

      // ── FPS + Perf Graph ──
      const fpsEl = $('fps');
      const perfGraph = $('perf-graph');
      const perfCanvas = $('perf-canvas');
      const perfCtx = perfCanvas.getContext('2d');
      const perfFpsEl = $('perf-fps');
      const perfCpuEl = $('perf-cpu-val');
      const perfGpuEl = $('perf-gpu-val');
      const DPR = window.devicePixelRatio || 1;
      const GW = 340,
        GH = 130,
        ML = 30;
      const PW = GW - ML,
        PH = GH;
      perfCanvas.width = GW * DPR;
      perfCanvas.height = GH * DPR;
      perfCanvas.style.width = GW + 'px';
      perfCanvas.style.height = GH + 'px';
      const N_SAMPLES = PW;
      const cpuSamples = new Float32Array(N_SAMPLES);
      const gpuSamples = new Float32Array(N_SAMPLES);
      let sampleIdx = 0,
        scaleMax = 20;
      let avgCpu = 0,
        avgGpu = 0,
        avgFps = 0;
      if (perfOpen) perfGraph.classList.add('open');

      fpsEl.addEventListener('click', () => {
        perfOpen = !perfOpen;
        perfGraph.classList.toggle('open', perfOpen);
        syncURL();
      });

      const TICKS = [2, 4, 8, 16, 32, 64];

      function drawPerfGraph() {
        const ctx = perfCtx;
        ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
        ctx.clearRect(0, 0, GW, GH);

        let dataMax = 1;
        for (let i = 0; i < N_SAMPLES; i++) {
          const total = cpuSamples[i] + gpuSamples[i];
          if (total > dataMax) dataMax = total;
          if (cpuSamples[i] > dataMax) dataMax = cpuSamples[i];
        }
        let ceilTick = TICKS[TICKS.length - 1];
        for (const t of TICKS) {
          if (t >= dataMax) {
            ceilTick = t;
            break;
          }
        }
        const target = Math.max(ceilTick * 1.1, 8);
        if (target > scaleMax) scaleMax = target;
        else scaleMax += (target - scaleMax) * 0.03;
        const sqrtMax = Math.sqrt(scaleMax);
        const toY = (ms) => PH - (Math.sqrt(Math.max(0, ms)) / sqrtMax) * PH;

        ctx.fillStyle = 'rgba(255,255,255,0.03)';
        ctx.fillRect(ML, 0, PW, PH);

        ctx.font = '9px monospace';
        ctx.textAlign = 'right';
        ctx.textBaseline = 'middle';
        for (const ms of TICKS) {
          if (ms > scaleMax * 0.98) continue;
          const y = toY(ms);
          if (y < 6 || y > PH - 4) continue;
          const isBudget = ms === 16 || ms === 32;
          ctx.strokeStyle = isBudget ? 'rgba(100,255,100,0.2)' : 'rgba(255,255,255,0.06)';
          ctx.lineWidth = 1;
          ctx.beginPath();
          ctx.moveTo(ML, y);
          ctx.lineTo(GW, y);
          ctx.stroke();
          ctx.fillStyle = isBudget ? 'rgba(100,255,100,0.5)' : 'rgba(255,255,255,0.25)';
          ctx.fillText(`${ms}`, ML - 3, y);
        }

        ctx.strokeStyle = 'rgba(255,255,255,0.12)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(ML, 0);
        ctx.lineTo(ML, PH);
        ctx.stroke();

        function drawLine(samples, color) {
          ctx.strokeStyle = color;
          ctx.lineWidth = 1.2;
          ctx.beginPath();
          for (let i = 0; i < N_SAMPLES; i++) {
            const si = (sampleIdx + i) % N_SAMPLES;
            const x = ML + i;
            const y = Math.max(0, Math.min(PH, toY(samples[si])));
            i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
          }
          ctx.stroke();
        }
        drawLine(cpuSamples, 'rgba(100,200,255,0.85)');
        drawLine(gpuSamples, 'rgba(255,150,80,0.85)');
      }

      let lastFpsUpdate = 0;
      (function tick(now) {
        const jsMs = hrc.jsTimeMs;
        const gpuMs = hrc.gpuTimeMs;

        avgCpu += (jsMs - avgCpu) * 0.05;
        if (gpuMs > 0) avgGpu += (gpuMs - avgGpu) * 0.05;
        const fps = hrc.fps;
        if (fps > 0) avgFps += (fps - avgFps) * 0.05;

        cpuSamples[sampleIdx] = jsMs;
        gpuSamples[sampleIdx] = gpuMs;
        sampleIdx = (sampleIdx + 1) % N_SAMPLES;

        if (now - lastFpsUpdate > 250) {
          lastFpsUpdate = now;
          fpsEl.textContent = `${Math.round(avgFps)} fps`;
        }
        if (perfOpen) {
          drawPerfGraph();
          perfFpsEl.textContent = `${Math.round(avgFps)} fps`;
          perfCpuEl.textContent = `js ${avgCpu.toFixed(1)}ms`;
          perfGpuEl.textContent = avgGpu > 0 ? `gpu ${avgGpu.toFixed(1)}ms` : 'gpu N/A';
        }
        requestAnimationFrame(tick);
      })(0);

      // ── Keyboard ──
      document.addEventListener('keydown', (e) => {
        if (e.target instanceof HTMLInputElement && e.target.type === 'text') return;
        const d = e.code.match(/^Digit(\d)$/);
        if (d) {
          e.preventDefault();
          e.target?.blur?.();
          e.shiftKey ? switchScene(+d[1]) : pickPreset(+d[1]);
          return;
        }
        let handled = true;
        switch (e.key) {
          case '=':
          case '+':
            pen.size = Math.min(50, pen.size + 2);
            sSize.value = pen.size;
            vSize.textContent = String(pen.size);
            hrc.setMouseLightRadius(pen.size / 2);
            break;
          case '-':
          case '_':
            pen.size = Math.max(1, pen.size - 2);
            sSize.value = pen.size;
            vSize.textContent = String(pen.size);
            hrc.setMouseLightRadius(pen.size / 2);
            break;
          case 'c':
          case 'C':
            hrc.clearLines();
            break;
          case 's':
          case 'S':
            hrc.saveScreenshot(`hrc-${Date.now()}.png`);
            break;
          case 'f':
          case 'F':
            if (document.fullscreenElement) document.exitFullscreen();
            else document.documentElement.requestFullscreen();
            break;
          case 't':
          case 'T': {
            const timings = hrc.gpuPassTimings;
            if (!timings.length) {
              console.log('No GPU pass timings available');
              break;
            }
            const groups = {};
            timings.forEach(({ label, ms }) => {
              const cat = label.replace(/\d+$/, '').replace(/\.[^.]*$/, '');
              const type = label.includes('.') ? label.split('.')[1].replace(/\d+$/, '') : label;
              groups[type] = (groups[type] || 0) + ms;
            });
            console.log(timings.map(({ label, ms }) => ({ pass: label, ms: ms.toFixed(3) })));
            console.table(Object.entries(groups).map(([type, ms]) => ({ type, ms: ms.toFixed(2) })));
            console.log(`Total: ${timings.reduce((s, t) => s + t.ms, 0).toFixed(2)}ms`);
            break;
          }
          case 'ArrowRight':
            switchScene((currentScene + 1) % scenes.length);
            break;
          case 'ArrowLeft':
            switchScene((currentScene - 1 + scenes.length) % scenes.length);
            break;
          case 'n':
          case 'N': {
            const cx = window.innerWidth / 2,
              cy = hrc.clientHeight / 2;
            const el = document.createElement('folk-shape');
            el.setAttribute('x', cx - 30);
            el.setAttribute('y', cy - 30);
            el.setAttribute('width', 60);
            el.setAttribute('height', 60);
            el.setAttribute('data-rgb', pen.color.join(','));
            el.setAttribute('data-opacity', String(pen.opacity));
            el.setAttribute('data-albedo', String(pen.albedo));
            hrc.appendChild(el);
            break;
          }
          case 'Delete':
          case 'Backspace':
            if (document.activeElement?.tagName === 'FOLK-SHAPE') {
              document.activeElement.remove();
              selectShape(null);
            }
            break;
          default:
            handled = false;
        }
        if (handled) {
          e.preventDefault();
          e.target?.blur?.();
        }
      });

      // ── Drawing ──
      let drawing = false,
        lastX = 0,
        lastY = 0;

      document.addEventListener('pointerdown', (e) => {
        if (e.target.tagName === 'FOLK-SHAPE' || e.target.closest('#panel') || e.target.closest('#bar')) return;
        const rect = hrc.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) return;
        if (selectedShape) {
          selectShape(null);
          e.preventDefault();
          return;
        }
        if (document.activeElement?.tagName === 'FOLK-SHAPE') document.activeElement.blur();
        drawing = true;
        lastX = e.clientX;
        lastY = e.clientY;
        e.preventDefault();
      });

      document.addEventListener('pointermove', (e) => {
        if (!drawing || e.buttons === 0) { drawing = false; return; }
        const dx = e.clientX - lastX,
          dy = e.clientY - lastY;
        if (Math.sqrt(dx * dx + dy * dy) >= 4) {
          if (pen.eraser) hrc.eraseAt(e.clientX, e.clientY, pen.size);
          else hrc.addLine(lastX, lastY, e.clientX, e.clientY, pen.color, pen.size, pen.opacity, pen.albedo);
          lastX = e.clientX;
          lastY = e.clientY;
        }
      });

      document.addEventListener('pointerup', (e) => {
        if (!drawing) return;
        if (pen.eraser) {
          hrc.eraseAt(e.clientX, e.clientY, pen.size);
        } else if (Math.abs(e.clientX - lastX) > 1 || Math.abs(e.clientY - lastY) > 1) {
          hrc.addLine(lastX, lastY, e.clientX, e.clientY, pen.color, pen.size, pen.opacity, pen.albedo);
        } else {
          hrc.addLine(lastX, lastY, lastX, lastY, pen.color, pen.size, pen.opacity, pen.albedo);
        }
        drawing = false;
      });
    